export const SKILL_STATUSES = ["Not Started", "Introduced", "Developing", "Demonstrated", "Mastered"];

export const STATUS_STYLE = {
  "Not Started": { bg: "bg-gray-100", text: "text-gray-600", dot: "#E5E7EB", pct: 0 },
  "Introduced": { bg: "bg-blue-50", text: "text-blue-700", dot: "#93C5FD", pct: 25 },
  "Developing": { bg: "bg-yellow-50", text: "text-yellow-700", dot: "#EAB308", pct: 55 },
  "Demonstrated": { bg: "bg-orange-50", text: "text-orange-700", dot: "#FB923C", pct: 80 },
  "Mastered": { bg: "bg-teal-light", text: "text-teal-dark", dot: "#2FB7B5", pct: 100 },
};

export const ADVANCEMENT_RULES = {
  teacher: "Teacher may mark complete",
  teacher_recommend: "Teacher recommends → Director approval",
  director: "Director only",
};

export function progressForSkills(skillProgress, requiredIds) {
  if (!requiredIds || requiredIds.length === 0) return 0;
  const map = {};
  skillProgress.forEach((s) => { map[s.skill_id] = s.status; });
  let total = 0;
  requiredIds.forEach((id) => {
    const st = map[id] || "Not Started";
    total += (STATUS_STYLE[st]?.pct || 0);
  });
  return Math.round(total / requiredIds.length);
}

export function initials(first, last) {
  return `${(first || "?")[0] || ""}${(last || "")[0] || ""}`.toUpperCase();
}
